import { trim } from 'lodash';
import { boolean, mixed, number, object, string } from 'yup';

import { Honorific } from '../../../../../data/types/api/graphql';
import { messages } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    honorific: mixed<Honorific>()
      .oneOf(Object.values(Honorific))
      .required(messages.required.id)
      .nullable(),
    healthProfessionalId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    irregular: boolean().default(false).nullable(),
    minutes: number()
      .transform(value => {
        const num = Number(value);
        return Number.isNaN(num) ? undefined : num;
      })
      .required(messages.required.id),
    slots: number()
      .transform(value => {
        const num = Number(value);
        return Number.isNaN(num) ? undefined : num;
      })
      .required(messages.required.id),
  })
  .required()
  .noUnknown();
